import { PlusWhiteImage } from '../../svgImages/PlusImage';
import type { ButtonProps } from '../types';

export const ButtonCaution: React.FC<
  ButtonProps & {
    prefixIcon?: 'plus';
  }
> = ({ text, width, prefixIcon = null, isLoading = false, ...attr }) => (
  <button
    type="button"
    className={
      width === 'fit'
        ? 'group relative flex min-h-10 w-fit appearance-none items-center justify-center rounded-2 p-3'
        : 'group relative flex min-h-10 w-full appearance-none items-center justify-center rounded-2 p-3'
    }
    {...attr}
  >
    <div className="absolute inset-0 rounded-2 bg-caution-primary transition-[filter] group-hover:brightness-110" />
    {isLoading && (
      <div className="absolute inset-y-0 right-2 my-auto size-4">
        <div className="size-full animate-spin rounded-[50%] border-2 border-b-base-40 border-l-base-100 border-r-base-40 border-t-base-100" />
      </div>
    )}
    <div className="relative flex w-fit items-center gap-1">
      {prefixIcon === 'plus' && <PlusWhiteImage alt="" className="size-4" />}
      <div className="cst-button-label-text text-base-100">{text}</div>
    </div>
  </button>
);
